import React from 'react';

const WideImage = ({ children }) => {
  return (
    <div className="not-prose my-6 rounded-sm overflow-hidden isolate lg:-mx-20 xl:-mx-40">
      {children}
    </div>
  );
};

export default WideImage;
